import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { SearchComponent } from '../../pages/search/search.component';
//import { AdvancedSearchPage } from '../../pages/advanced-search/advanced-search.page';
import { GlobalService } from '../../services/global.service';
import { advancedSearchComponent } from 'src/app/pages/advanced-search/advanced-search.component';


@Component({
  selector: 'app-searchbar',
  templateUrl: './searchbar.component.html',
  styleUrls: ['./searchbar.component.scss'],
})
export class SearchbarComponent implements OnInit {

  constructor(private modalController: ModalController,
                public global: GlobalService) { }

  ngOnInit() { }

  async gotoSearchPage() 
  {
    const modal = await this.modalController.create({
        component: advancedSearchComponent,
        cssClass: 'custom-modal'
        });
        
    return await modal.present();
  }

}
